import { Divider, Grid2, Typography, useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import React from 'react';
import { defineMessages, useIntl } from 'react-intl';

const messages = defineMessages({
  'column.active': {
    id: 'patientPlanTable.column.active',
    defaultMessage: 'Active',
  },
  'column.invited': {
    id: 'patientPlanTable.column.invited',
    defaultMessage: 'Invited',
  },
  'column.new': {
    id: 'patientPlanTable.column.new',
    defaultMessage: 'New',
  },
  'column.plan': {
    id: 'patientPlanTable.column.plan',
    defaultMessage: 'Plan',
  },
  'column.purchased': {
    id: 'patientPlanTable.column.purchased',
    defaultMessage: 'Purchased',
  },
  'column.totalAssigned': {
    id: 'patientPlanTable.column.totalAssigned',
    defaultMessage: 'Total Assigned',
  },
});

interface PatientPlanMobileRowProps {
  /** Number of total rows */
  count: number;
  /** Table column values (order matters!) */
  data: (string | React.ReactNode)[];
  /** Index of current row */
  dataIndex: number;
}

export default function PatientPlanMobileRow({
  count,
  data,
  dataIndex,
}: PatientPlanMobileRowProps) {
  const { formatMessage } = useIntl();
  const { breakpoints } = useTheme();
  const isPhone = useMediaQuery(breakpoints.down(400));
  const [
    name,
    plan_limit,
    new_users,
    invited_users,
    active_users,
    total_assigned,
    edit,
  ] = data;

  const userPlanTypes = [
    {
      count: new_users,
      label: messages['column.new'],
    },
    {
      count: invited_users,
      label: messages['column.invited'],
    },
    {
      count: active_users,
      label: messages['column.active'],
    },
    {
      count: total_assigned,
      label: messages['column.totalAssigned'],
    },
  ];

  const baseGridItemProps = {
    alignItems: 'center',
    display: 'flex',
    columnGap: 0.5,
  };

  return (
    <tr key={dataIndex} style={{ height: 'auto' }}>
      <td style={{ paddingTop: dataIndex === 0 ? 20 : 10, paddingBottom: 5 }}>
        <Grid2 container p={2} spacing={3}>
          <Grid2 size={{ xs: 12, sm: 6 }} sx={{ ...baseGridItemProps }}>
            {name}
            {edit}
          </Grid2>
          <Grid2
            size={{ xs: 12, sm: 6 }}
            textAlign={isPhone ? 'left' : 'right'}
          >
            {plan_limit}
          </Grid2>

          {userPlanTypes.map(({ count, label }) => (
            <Grid2
              key={`${label.id}-${count}`}
              size={{ xs: 6, sm: 3 }}
              sx={{ ...baseGridItemProps, mt: 1 }}
            >
              <Typography variant="caption">{formatMessage(label)}</Typography>
              {count}
            </Grid2>
          ))}
        </Grid2>

        {dataIndex + 1 !== count && <Divider />}
      </td>
    </tr>
  );
}
